export default {
  // mutationName: (state, value) => {}

  STORE_NODES_AND_LINKS: (state, updatedData) => {
    state.nodes = updatedData.nodes
    state.links = updatedData.links
  }
}
